import sharedFilters from './shared';
import { getDaysInPast, getRangeFromDays } from '../../utils/dates';

const thirtyDaysInPast = getDaysInPast(30);
const thirtyDaysRange = getRangeFromDays(30);

export default {
  pageFilters: [
    {
      label: 'Content',
      id: 'content',
      filters: {
        show: sharedFilters.show,
        network: sharedFilters.network,
        genre: sharedFilters.genre,
        release_date: sharedFilters.release_date,
        originating_country: sharedFilters.originating_country,
        originating_language: sharedFilters.originating_language,
        airing_status: sharedFilters.airing_status,
        runtime: null
      }
    },
    {
      label: 'Users',
      id: 'users',
      filters: {
        country: sharedFilters.country,
        panel: sharedFilters.sampleBalance,
        gender: sharedFilters.gender,
        age: sharedFilters.age
      }
    },
    {
      label: 'Date',
      id: 'date',
      filters: {
        date: Object.assign({}, sharedFilters.date, {
          isAliasMode: true,
          value: {
            ...thirtyDaysInPast,
            aliasValue: thirtyDaysRange.value
          }
        })
      }
    },
    {
      label: 'Metric',
      id: 'metric',
      filters: {
        metric: null
      }
    },
    {
      id: 'segments',
      label: 'Saved Filters',
      filters: {
        segments: sharedFilters.segments
      }
    }
  ],
  queries: {
    showSummary: {
      fields: [
        'show',
        'genre',
        'network',
        'country',
        'age',
        'gender',
        'date',
        'runtime',
        'metric',
        'panel',
        'originating_country',
        'originating_language',
        'airing_status',
        'release_date'
      ]
    }
  }
};
